import { jsx as _jsx } from "react/jsx-runtime";
import { NavLink } from 'react-router-dom';
import { appSections } from '../appSections';
import { ProtectedRoute } from '../components';
const { rootPath, linkTo, title, claimIds } = appSections.orders;
export const ordersRoute = {
    path: rootPath,
    lazy: async () => {
        const { Orders } = await import('@/admin/modules/orders');
        return {
            element: (_jsx(ProtectedRoute, { claims: claimIds, children: _jsx(Orders, {}) })),
        };
    },
    handle: {
        crumb: () => _jsx(NavLink, { to: linkTo, children: title }),
    },
};
